var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.period)?_c('div',{staticClass:"body-2 no-period"},[_vm._v("None")]):_c('div',{staticClass:"period"},[_c('div',{staticClass:"body-2 period-type"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.period.type)))]),_c('div',{staticClass:"caption grey--text period-dates"},[_vm._v(_vm._s(_vm.period.dates))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }